/*
* Project: LegalPlace assistant
* File: src/components/utils/radio_show.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

// Solving the problem to which parent are able to show their radio children or not.
import lpApp from '../../app/lp_app';
import ConditionsEvo from '../../logic/condition_evo';

let radioParents = {};

function rsRegisterAction(id, parent, isDuplicate, copy) {
  const actualComponent = lpApp.references.getOption(id);
  if (actualComponent.meta.type !== 'radio') return false;
  const pId = isDuplicate ? `${parent}_${copy}` : parent;
  if ((actualComponent.children.length === 0) && (actualComponent.variables.length === 0)) {
    // build key
    radioParents[pId] = true;
  } else if (actualComponent.variables.length > 0) {
    radioParents[pId] = false;
  } else {
    const { children } = actualComponent;
    // let variables = actualComponent.variables;
    let hAwlad = true;
    children.map((idx) => {
      if (lpApp.references.getOption(idx).meta.type !== 'hidden') {
        // test the conditional thing
        const wOption = lpApp.references.getOption(idx);
        if (wOption.meta.conditional && (wOption.meta.compiledConditions.length > 0)) {
          // let c = new ConditionRuntime(wOption.meta.compiledConditions);
          // c.compileDirect();
          // if(c.execute())
          //     hAwlad = false;
          // let c = new ConditionRuntime(wOption.meta.compiledConditions);
          // c.compileDirect();
          if (ConditionsEvo.getCondition(idx)) hAwlad = false;
        } else hAwlad = false;
      }
    });
    radioParents[pId] = hAwlad ? true : undefined;
  }
  window.aaaa = radioParents;
  return true;
}


function rsRemove(id) {
  const newRadios = {};
  Object.keys(radioParents).map((idx) => {
    if (idx !== id) newRadios[idx] = radioParents[idx];
  });
  radioParents = newRadios;
}
function rsDoICome(id, parent, isDuplicate, copy) {
  if (typeof id === 'undefined') return null;
  if (id.length) return null;
  const actualComponent = lpApp.references.getOption(id);

  if (actualComponent.meta.type !== 'radio') {
    return null;
  }
  const pId = isDuplicate ? `${parent}_${copy}` : parent;

  return radioParents[pId];
}

export {
  rsRegisterAction,
  rsDoICome,
  rsRemove,
};



// WEBPACK FOOTER //
// ./src/components/utils/radio_show.js